import { Link } from 'react-router-dom';
import '../styles/platform.css';
import '../styles/platform.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function Uxcreator() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <section id="uxcreator-banner" className="ux-banner">
        <div
          className="m-auto banner-container"
          data-aos="fade-right"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <div className="mb-32">
            <img src="./images/logo-uxcreator.svg" alt="uxcreatorlogoimage" />
          </div>
          <p
            className="fs-md fw-bold mb-60"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="100"
          >
            UXBooster를 기본으로 코딩없이
            <br />
            업무화면 · 소스코드를 자동 생성해주는 플랫폼
          </p>
          <ul
            className="ux-button"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <li>
              <Link to="/contact?service=uxcreator&no=02" className="btn-outline fw-bold">
                소개자료 문의
              </Link>
            </li>
            <li>
              <Link to="/contact?service=uxcreator&no=01" className="btn-filled fw-bold">
                서비스 도입 문의
              </Link>
            </li>
          </ul>
        </div>
      </section>

      <section id="uxcreator-intro">
        <div className="m-auto content-padding">
          <h3 className="ux-content-title02">
            <strong>UXCreator</strong> 를 사용해야 하는 이유
          </h3>
          <p className="content-subtitle fs-md">
            미리 구축된 모듈과 인터페이스에서
            <br className="pc-none" /> 단순 기능조작만으로 앱 개발
          </p>
          <div className="content-bg content-gap reason02-container">
            <div className="content-box ux-boxbar-x reason02-box">
              <ul>
                <li>
                  <img src="./images/ico-uxcreator-reason01.svg" alt="" />
                  <p className="fs-base fw-md">
                    업무화면 생성&nbsp;
                    <br className="mo-none" />
                    자동화 시스템
                  </p>
                </li>
                <li>
                  <img src="./images/ico-uxcreator-reason02.svg" alt="" />
                  <p className="fs-base fw-md">
                    템플릿&nbsp;
                    <br className="mo-none" />
                    커스터마이징
                  </p>
                </li>
                <li>
                  <img src="./images/ico-uxcreator-reason03.svg" alt="" />
                  <p className="fs-base fw-md">
                    대량의 화면&nbsp;
                    <br className="mo-none" />
                    일괄 생성
                  </p>
                </li>
                <li>
                  <img src="./images/ico-uxcreator-reason04.svg" alt="" />
                  <p className="fs-base fw-md">
                    쉬운 사용법,&nbsp;
                    <br className="mo-none" />
                    빠른 구축시간
                  </p>
                </li>
                <li>
                  <img src="./images/ico-uxcreator-reason05.svg" alt="" />
                  <p className="fs-base fw-md">
                    퀄리티와&nbsp;
                    <br className="mo-none" />
                    업무 만족도 UP
                  </p>
                </li>
              </ul>
            </div>
            <div className="arrow">
              <img src="./images/ux-arrow.svg" alt="아래화살표" />
            </div>
            <div className="reason02-fin fs-md fw-bold">개발기간 단축 및 업무 효율성 증대</div>
          </div>
          <h3 className="ux-content-title02">
            <strong>No-Code · Low-Code</strong>
          </h3>
          <p className="fs-md content-subtitle text-center">
            개발자의 작업을 최소화하고,
            <br className="pc-none" /> 높은 수준의 사양을 기능 코드로 변환하여
            <br />
            누구나 쉽고 빠르게 앱 개발을 할 수 있습니다.
          </p>
          <div className="content-bg uxcreator-strength-container">
            <div className="uxcreator-strength-content">
              <div className="uxcreator-strength-box content-box">
                <img src="./images/ico-uxcreator-strength01.svg" alt="" />
                <p className="fs-base text-center">
                  업무화면 개발에 필수적인
                  <br />
                  대표 콘텐츠 4종 구성
                </p>
              </div>
              <div className="uxcreator-strength-box content-box">
                <img src="./images/ico-uxcreator-strength02.svg" alt="" />
                <p className="fs-base text-center">
                  업무화면 개발에 최적화된
                  <br />
                  템플릿 7종 제공
                </p>
              </div>
              <div className="uxcreator-strength-box content-box">
                <img src="./images/ico-uxcreator-strength03.svg" alt="" />
                <p className="fs-base text-center">
                  사용자 친화적인
                  <br />
                  인터페이스로 접근성 용이
                </p>
              </div>
            </div>
            <div className="arrow">
              <img src="./images/ux-arrow.svg" alt="아래화살표" />
            </div>
            <div className="uxcreator-strength-content">
              <div className="uxcreator-strength-box02 content-box ux-boxbar-x">
                <p className="fs-md fw-bold text-center color-uxb">전문 개발자</p>
                <div className="uxcreator-strength-item01 fs-base">
                  반복적인 단순한 코드 작성 시간 최소화
                </div>
                <div className="miniarrow">
                  <img src="./images/ux-minarrow.svg" alt="아래화살표" />
                </div>
                <div className="uxcreator-strength-item02 fs-base fw-bold">
                  문제해결, 창의성을 요구하는
                  <br />
                  개발에 집중하도록 지원
                </div>
              </div>
              <div className="uxcreator-strength-box02 content-box ux-boxbar-x">
                <p className="fs-md fw-bold text-center color-uxb">비전문가</p>
                <div className="uxcreator-strength-item01 fs-base">
                  UXCreator 기본적인 사용법 학습
                </div>
                <div className="miniarrow">
                  <img src="./images/ux-minarrow.svg" alt="아래화살표" />
                </div>
                <div className="uxcreator-strength-item02 fs-base fw-bold">
                  프로그래밍 경험이 없는 비전문가도
                  <br />앱 개발에 참여할 수 있는 기회 제공
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="uxcreator-workflow">
        <div className="m-auto content-padding">
          <p className="color-uxb fs-base fw-bold mb-8">WORK FLOW</p>
          <h3 className="ux-content-title">
            <strong>UXCreator</strong> Process
          </h3>
          <div className="img-uxboard-process">
            <img src="./images/img-uxcreator-process01.svg" alt="uxboard-process" />
          </div>
          <div className="img-uxboard-process-mo">
            <img src="./images/img-uxcreator-process01-mo.svg" alt="uxboard-process" />
          </div>
          <h3 className="ux-content-title mt-100">
            <strong>UXCreator</strong> 구축 상세과정
          </h3>
          <div className="img-uxboard-process">
            <img src="./images/img-uxcreator-process02.svg" alt="uxboard-process" />
          </div>
          <div className="img-uxboard-process-mo">
            <img src="./images/img-uxcreator-process02-mo.svg" alt="uxboard-process" />
          </div>
        </div>
      </section>
      <section id="uxcreator-effect">
        <div className="m-auto content-padding">
          <h3 className="ux-content-title">
            <strong>UXCreator</strong> 도입 기대효과
          </h3>
          <div className="uxcreator-effect-container">
            <div className="uxcreator-effect-content">
              <div className="uxcreator-effect-box content-box ux-boxbar-y">
                <img src="./images/ico-uxcreator-effect01.svg" alt="" />
                <div className="uxcreator-effect-text">
                  <p className="fs-md fw-bold color-uxb">업무의 효율성 극대화</p>
                  <ul>
                    <li className="fs-base">개발 프로세스 간소화</li>
                    <li className="fs-base">인적 오류 최소화</li>
                  </ul>
                </div>
              </div>
              <div className="uxcreator-effect-box content-box ux-boxbar-y">
                <img src="./images/ico-uxcreator-effect02.svg" alt="" />
                <div className="uxcreator-effect-text">
                  <p className="fs-md fw-bold color-uxb">코드의 재사용성</p>
                  <ul>
                    <li className="fs-base">사용자 중심의 인터페이스로 수정</li>
                    <li className="fs-base">최적화된 소스로 유지관리 용이</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="uxcreator-effect-content">
              <div className="uxcreator-effect-box content-box ux-boxbar-y">
                <img src="./images/ico-uxcreator-effect03.svg" alt="" />
                <div className="uxcreator-effect-text">
                  <p className="fs-md fw-bold color-uxb">개발비용 절감</p>
                  <ul>
                    <li className="fs-base">개발 기간 단축</li>
                    <li className="fs-base">인력자원 탄력적 운용 가능</li>
                  </ul>
                </div>
              </div>
              <div className="uxcreator-effect-box content-box ux-boxbar-y">
                <img src="./images/ico-uxcreator-effect04.svg" alt="" />
                <div className="uxcreator-effect-text">
                  <p className="fs-md fw-bold color-uxb">시장 경쟁우의 확보</p>
                  <ul>
                    <li className="fs-base">빠른 시장 진입</li>
                    <li className="fs-base">비즈니스 민첩성 확보</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="ux-contact">
        <div className="contact-container m-auto">
          <div
            className="contact-text"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
          >
            <p className="fs-xxl">지금 바로</p>
            <img src="./images/logo-uxcreator-white.svg" alt="uxcreator-logo" />
            <p className="fs-xxl">를 만나보세요!</p>
          </div>
          <div
            className="contact-button fs-base"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <Link to="/contact?service=uxcreator&no=01" className="color-uxb">
              서비스 도입 문의
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Uxcreator;
